export const FAVORITE_RECIPE = "FAVORITE_RECIPE"